import Image from 'next/image';

type CampaignImagesProps = {
  campaignToken0Name: string;
  campaignToken0Image: string;
  campaignToken1Name: string;
  campaignToken1Image: string;
  isType1Campaign: boolean;
};

const PlaceholderImage = ({ className }: { className?: string }) => (
  <div className={`rounded-full h-7 w-7 bg-neutral-700 ${className}`} />
);

const TokenImage = ({ src, alt, className }: { src: string; alt: string; className?: string }) => (
  <Image src={src} width={27} height={27} alt={alt} className={`rounded-full ${className}`} />
);

export const CampaignImages = ({
  campaignToken0Name,
  campaignToken0Image,
  campaignToken1Name,
  campaignToken1Image,
  isType1Campaign,
}: CampaignImagesProps) => {
  const coinGeckoMissingLogoString = 'missing.png';

  const hasImage = (image: string) => image && image !== coinGeckoMissingLogoString;

  const renderToken0Image = () =>
    hasImage(campaignToken0Image) ? (
      <TokenImage src={campaignToken0Image} alt={`${campaignToken0Name} icon`} />
    ) : (
      <PlaceholderImage />
    );

  const renderToken1Image = () =>
    hasImage(campaignToken1Image) ? (
      <TokenImage src={campaignToken1Image} alt={`${campaignToken1Name} icon`} className="-ml-3 z-10" />
    ) : (
      <PlaceholderImage className="-ml-3 z-10" />
    );

  return isType1Campaign ? (
    renderToken0Image()
  ) : (
    <div className="flex items-center">
      {renderToken0Image()}
      {renderToken1Image()}
    </div>
  );
};
